// extracted by mini-css-extract-plugin
module.exports = {"slider":"slider-module--slider--lXStJ","scroller":"slider-module--scroller--1p7u_","prev":"slider-module--prev--3QAxq","next":"slider-module--next--1hd0V"};